// System health (admins only): each app's live check, status and AWS metrics.
const API_URL = process.env.REACT_APP_API_URL;

// range: today | yesterday | thisWeek | last7d | thisMonth | last30d.
// fresh: skip the server's one-minute cache (the Refresh button).
export async function getSystemHealth(range, { fresh = false } = {}) {
  const token = localStorage.getItem("accessToken");
  const res = await fetch(`${API_URL}/api/system-health?range=${encodeURIComponent(range)}${fresh ? "&fresh=1" : ""}`, {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
  const json = await res.json().catch(() => ({}));
  if (!res.ok || json.success === false) {
    const err = new Error(res.status === 403 ? "This page is for admins only." : json.message || `Request failed (${res.status})`);
    err.status = res.status;
    throw err;
  }
  return json.data;
}
